'use client'
import { Common } from '@/config/NextImport'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'

const ProductDescription = (props: any) => {
  const pathname = usePathname()
  const [selectedProductOptions, setSelectedProductOptions] = useState<any[]>([])
  const productDetail = props.productDetail || {}
  const sku = pathname.split('-sku-').reverse()[0]
  const products = props.products || []
  const options = props.options || []

  useEffect(() => {
    if (!products.length || !sku) return

    const product = products.find((x: any) => x.sku === sku)
    if (!product) return

    // ✅ parse & filter standalone = 0 only
    const variantAttributes =
      Common.GetJSON(product.attribute_options)?.filter((attr: any) => attr.Is_standalone === 0) ||
      []

    const mergedOptions = options.map((opt: any) => {
      const matched = variantAttributes.find((attr: any) => attr.title === opt.attribute_name)

      return {
        ...opt,
        selected_value_label: matched?.value || '-',
        selected_image: matched?.image || null
      }
    })
    setSelectedProductOptions(mergedOptions)
  }, [pathname, products, sku])
  const description =
    productDetail.product_description?.replace(/\{\{(.*?)\}\}/g, (_match: string, p1: string) => {
      const option = selectedProductOptions.find(
        (x: any) => x.attribute_name?.toLowerCase().trim() === p1.toLowerCase().trim()
      )

      return option?.selected_value_label || ''
    }) || null

  return (
    <div className="col-lg-6 col-xl-4">
      <div className="product-detail-left diamond-tabs">
        <div
          className="accordion"
          id="Diamond-Detailtab"
        >
          <div className="accordion-item">
            <h2
              className="accordion-header"
              id="headingOne"
            >
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#diamond-tab1"
              >
                Setting Details
              </button>
            </h2>

            <div
              id="diamond-tab1"
              className="accordion-collapse collapse show"
            >
              <div className="accordion-body p-0">
                <p className="fs-14 p-1 mb-2">{description}</p>
                <table className="table">
                  <tbody>
                    <tr>
                      <td>SKU</td>
                      <td>{sku}</td>
                    </tr>

                    {selectedProductOptions
                      .filter((x) => x.Is_standalone === 0)
                      .map((item: any, index: number) => (
                        <tr key={index}>
                          <td>{item.attribute_name}</td>
                          <td>{item.selected_value_label}</td>
                        </tr>
                      ))}

                    {/* Existing static product details */}
                    {productDetail.product_details &&
                      Common.GetJSON(productDetail.product_details)?.map(
                        (item: any, index: number) => (
                          <tr key={index}>
                            <td>{item.label}</td>
                            <td>{item.value}</td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductDescription
